

const WodaMieszkancySeryjneTabela = props => {

    const { zestaw } = props;

    const wiersze = zestaw?.map( (z, i) => {
        const uwagi = z?.procent?.zuzycieMieszkanca == 0 ? 'brak wprowadzonych odczytów' : ''
        return (
            <tr key={i}>
                <td style={{textAlign: "left"}}>
                    {`${z.mieszkaniec.imie_nazwisko} (id ${z.mieszkaniec?.id_user})`}
                </td>
                <td style={{textAlign: "left", whiteSpace: "nowrap"}}>
                    {z.adres}
                </td>
                <td>
                    {uwagi}
                </td>
                <td>

                </td>
            </tr>
        )
    })

    return (
        <div className="tabela-ramka ramka">
            <table className="tabela mieszkancy">
                <thead>
                    <tr>
                        <th>
                            Mieszkaniec
                        </th>
                        <th>
                            Adres
                        </th>
                        <th>
                            Uwagi
                        </th>
                        <th>

                        </th>
                    </tr>
                </thead>
                <tbody>
                    { wiersze }
                </tbody>
            </table>
        </div>
    )
}

export default WodaMieszkancySeryjneTabela;